import { IECommerceSubscription } from 'shared/interfaces/ecommerce-subscription.interface';
import { http } from '../utils/axios';

class SubscriptionService {
  private static instance: SubscriptionService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): SubscriptionService {
    if (!SubscriptionService.instance) {
      SubscriptionService.instance = new SubscriptionService();
    }

    return SubscriptionService.instance;
  }

  public getSubscriptionInfo = async ({ limit = 20, page = 1 }) => {
    const data = await http<{
      result: IECommerceSubscription[];
      count: number;
    }>({
      url: '/ecommerceSubscriptions',
      method: 'GET',
      params: {
        limit,
        page
      }
    });
    return data;
  };

  public getOneSubscription = async (id: string) => {
    const { data } = await http<IECommerceSubscription>({
      url: `/ecommerceSubscriptions/${id}`,
      method: 'GET'
    });
    return data;
  };

  public updateSubscription = async (id: string, subscriptionData: any) => {
    const { data } = await http<IECommerceSubscription>({
      url: `/ecommerceSubscriptions/${id}`,
      method: 'PUT',
      data: subscriptionData
    });

    return data;
  };

  public getSubscriptionVariationsInfo = async ({
    limit = 20,
    page = 1,
    isMapped = undefined
  }) => {
    const data = await http<{
      result: IECommerceSubscription[];
      count: number;
    }>({
      url: '/ecommerceSubscriptionVariations/mapping',
      method: 'GET',
      params: {
        limit,
        page,
        isMapped
      }
    });
    return data;
  };

  public mapEcommerceSubscriptionVariation = async (
    epvtId: string,
    payload: any
  ) => {
    const { data } = await http<any>({
      url: `/ecommerceSubscriptionVariations/${epvtId}/mapping`,
      method: 'POST',
      data: payload
    });

    return data;
  };

  public createSubscription = async (payload: any) => {
    const { data } = await http<IECommerceSubscription>({
      url: '/ecommerceSubscriptions',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public cancelSubscription = async (id: string) => {
    const { data } = await http<IECommerceSubscription>({
      url: `/ecommerceSubscriptions/${id}/cancel`,
      method: 'PATCH'
    });

    return data;
  };
}

const instance = SubscriptionService.getInstance();

export default instance;
